import { Text, View, StyleSheet, Svg, Circle } from "@react-pdf/renderer";
import { blue, red, green, yellow, orange } from "./pdfCssStyles";

const styles = StyleSheet.create({
  circleContainer: {
    flexDirection: "column",
    alignItems: "flex-start", // Prevent centering that may push content down
    // marginTop: -150, // without this the legend is placed to low on the page
  },
  circleRow: {
    flexDirection: "row", // Align circle and text in the same row
    alignItems: "left", // Align items vertically in the center
    marginBottom: 5, // Space between each row
  },
  circleText: {
    fontSize: 10,
    marginLeft: 5, // Space between circle and text
  },
});

const riskLevels = [
  { color: "white", label: " - Nessun rischio" },
  { color: blue, label: " - Rischio molto basso / basso" },
  { color: green, label: " - Rischio basso / moderato" },
  { color: yellow, label: " - Rischio moderato / significativo" },
  { color: orange, label: " - Rischio alto" },
  { color: red, label: " - Rischio alto / molto alto" },
];

export const RiskColorsLegend = () => (
  <View style={styles.circleContainer}>
    {riskLevels.map((risk, i) => (
      <View style={styles.circleRow} key={i}>
        <Svg height="16" width="16">
          <Circle cx="8" cy="8" r="6" stroke="black" strokeWidth="0.5" fill={risk.color} />
        </Svg>
        <Text style={styles.circleText}>{risk.label}</Text>
      </View>
    ))}
  </View>
);
